module.exports = __webpack_public_path__ + "img/dechirure.c55c2df6.svg";